import { Phone } from "lucide-react";
import Logo from "./Logo";

const PHONE_DISPLAY = "09 72 12 46 84";
const PHONE_HREF = "tel:+33972124684";

export default function Header() {
  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-2xl border-b pc-line" data-testid="site-header">
      <div className="mx-auto max-w-6xl px-5 lg:px-8 h-[60px] flex items-center justify-between gap-4">
        <a href="/#hero" className="flex items-center gap-2.5" data-testid="brand-link">
          <Logo size={22} />
          <span className="font-medium text-[17px] pc-text-ink tracking-[-0.015em]">Prévention Conseil</span>
        </a>

        <nav className="hidden md:flex items-center gap-9 text-[14px] pc-text-muted">
          <a href="/#opportunite" className="hover:pc-text-ink transition-colors" data-testid="nav-opportunite">Opportunité</a>
          <a href="/#methode" className="hover:pc-text-ink transition-colors" data-testid="nav-methode">Méthode</a>
          <a href="/#confiance" className="hover:pc-text-ink transition-colors" data-testid="nav-confiance">Garanties</a>
          <a href="/#faq" className="hover:pc-text-ink transition-colors" data-testid="nav-faq">FAQ</a>
        </nav>

        <div className="flex items-center gap-4">
          <a
            href={PHONE_HREF}
            className="hidden sm:flex items-center gap-1.5 text-[13.5px] font-medium pc-text-ink hover:pc-text-blue transition-colors"
            data-testid="header-phone"
          >
            <Phone className="w-3.5 h-3.5" strokeWidth={2.2} />
            <span className="font-mono-num">{PHONE_DISPLAY}</span>
          </a>
          <a
            href="/#form-final"
            className="btn-primary text-[13.5px] !py-2 !px-4 hidden md:inline-flex items-center"
            data-testid="header-cta"
          >
            Vérifier mon éligibilité
          </a>
        </div>
      </div>
    </header>
  );
}
